import { useContext } from 'react';
import { Modal } from '../../../../SubComponents/Modals';
import CustomerInfo from '../../../../ui-components/CustomerInfo';
import PaymentForm from './payment-form';
import ConfirmationForm from './confirmation-form';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as Close } from '../../../../Assets/Icons/close.svg';
import { CloseButton } from '../../../../SubComponents/Buttons';
import useBookingPrices from '../../../../Hooks/use-booking-prices';
import { bookingState } from '../../client-state/booking-state-context';
import { isSummaryOpenActionTypes } from '../../../../redusers/is-summary-open-reducer';
import { paymentReducerActionTypes } from '../../../../redusers/payment-reducer';
import useBookingMinimalShop from '../../server-data/use-booking-minimal-shop';

export interface CustomerData {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  phone?: string | null;
}

const PaymentModalWrapper = () => {
  const { data: minimalShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { bookingPrices } = useBookingPrices();

  const isShopCountryItaly = minimalShop?.country === 'Italy';

  return (
    <Modal style={{ marginBottom: isMobile ? '200px' : '32px' }}>
      {isMobile && (
        <CloseButton
          icon={Close}
          altText="Close payment modal"
          onClick={() => {
            dispatch({
              type: isSummaryOpenActionTypes.SET_IS_OPEN,
              payload: false,
            });
            dispatch({
              type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL,
              payload: false,
            });
          }}
        />
      )}

      {isShopCountryItaly ? null : (
        <CustomerInfo customer={state.customer.customer} showBirthDate={false} />
      )}

      {bookingPrices.balance && bookingPrices.balance < 0 ? (
        <PaymentForm />
      ) : (
        <ConfirmationForm />
      )}
    </Modal>
  );
};

export default PaymentModalWrapper;
